import { useSelector } from 'react-redux';
import { measurementsSelector } from '../../../store/slices/measurementsSlice/measurementsSlice';

export const useMeasurementsList = () => {
    const measurementsIds = useSelector(measurementsSelector.selectIds);

    return {
        measurementsIds,
    };
};
